import { RouteVia, RouteViaLabels } from "../../../../enums/routeVia";

export const allRouteViaOptions = [
  { label: RouteViaLabels[RouteVia.CMM], value: RouteVia.CMM },
  { label: RouteViaLabels[RouteVia.SURESCRIPTS], value: RouteVia.SURESCRIPTS },
  { label: RouteViaLabels[RouteVia.PROMPTPA], value: RouteVia.PROMPTPA },
  { label: RouteViaLabels[RouteVia.PHONEPA], value: RouteVia.PHONEPA },
  { label: RouteViaLabels[RouteVia.FAXPA], value: RouteVia.FAXPA },
  { label: RouteViaLabels[RouteVia.OTHERS], value: RouteVia.OTHERS },
];
